import { CommonModule, isPlatformBrowser } from "@angular/common";
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { GlobalConstants } from "../../global-constants";
import { CookieService } from "ngx-cookie-service";
import { ConsentService } from "@src/app/servicios/consent/consent.service";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: "app-navbar-iframes",
  templateUrl: "./navbar-iframes.component.html",
  styleUrls: ["./navbar-iframes.component.css"],
  imports: [CommonModule], // ✅ IMPORTANTE
  standalone: true,
})

// Este componente no se usa
export class NavbarIframesComponent implements OnInit, OnDestroy {
  canales: any[] = [];
  footer: any = {};
  public isBrowser: boolean;
  public dominios: SafeResourceUrl[] = [];
  public constantesGlobales: any;
  public isInIframe: boolean = false;
  private consentSubscription!: Subscription;
  private pageviewsSent = false;
  private imagePixels: HTMLImageElement[] = [];

  constructor(
    public sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    private readonly cookieService: CookieService,
    private readonly cd: ChangeDetectorRef,
    private readonly consentService: ConsentService,
    private route: ActivatedRoute,
  ) {
    // ✅ Inicializar array vacío siempre
    this.dominios = [];
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // ... existing code ...
  ngOnInit(): void {
    if (!this.isBrowser) return;

    // ✅ DETECCIÓN DOBLE: Por ventana y por parámetro en URL
    const urlParams = new URLSearchParams(window.location.search);
    const inIframeParam = urlParams.get("inIframe") === "true";
    this.isInIframe = window.self !== window.top || inIframeParam;

    if (this.isInIframe) {
      //   console.log("🚫 Estamos dentro de un iframe, de un webview o en un dispositivo móvil, no cargamos el footer de iframes.");
      return; // No ejecutamos el resto de la lógica
    }
    // 1. ✅ CARGA INICIAL INMEDIATA
    // Llamamos con un objeto por defecto para que 'dominios' se llene
    // y no veas el mensaje de "Cargando..."
    this.cargarIframes({ init: false });

    // 2. ✅ ESCUCHA ACTIVA
    // Cuando el servicio emita el valor real (ya sea por cookie o por clic en Google)
    // los iframes se actualizarán con 'cookiesAccepted=true'
    this.consentSubscription = this.consentService.consents.subscribe((consents) => {
      //   console.log("🔄 Sincronizando iframes con nuevo consentimiento:", consents.init);
      this.cargarIframes(consents);
    });
  }
  /*private cargarIframesLocal(consent: any): void {
    try {
      if (!this.isBrowser) return;

      this.constantesGlobales = new GlobalConstants("all");
      const tempDominios: SafeResourceUrl[] = [];

      if (this.constantesGlobales) {
        for (const key in this.constantesGlobales) {
          if (key.startsWith("tribuna")) {
            // ✅ SIMULACIÓN: En lugar de usar el dominio de Tribuna, usamos localhost
            let url = "http://localhost:4200";

            // ✅ Añadimos el parámetro inIframe para que el contenido del iframe
            // sepa que debe activar la clase .in-iframe-context y ocultar cosas
            const params = [`inIframe=true`];

            if (consent && (consent.init === true || consent.rendimiento === true)) {
              params.push(`cookiesAccepted=true`);
            }

            url += "?" + params.join("&");
            tempDominios.push(this.sanitizer.bypassSecurityTrustResourceUrl(url));
          }
        }
      }

      if (tempDominios.length > 0) {
        // ✅ 4. Forzar cambio de referencia del array para que Angular re-renderice
        this.dominios = [...this.shuffle(tempDominios).slice(0, 5)];
        this.cd.detectChanges();
      }
    } catch (error) {
      console.error("❌ Error cargando iframes:", error);
    }
  }*/
  private cargarIframes(consent: any): void {
    // alert("🔍 Valor de consent en iframes: " + JSON.stringify(consent));
    try {
      if (!this.isBrowser) return;

      this.constantesGlobales = new GlobalConstants("all");
      const currentConfig: any = new GlobalConstants(window.location.hostname);
      const currentDomain = currentConfig?.siteDomain || "";

      const tempItems: { url: SafeResourceUrl; idAnalytic: string; siteName: string; siteDomain: string }[] = [];
      const addedDomains = new Set<string>();

      if (this.constantesGlobales) {
        for (const key in this.constantesGlobales) {
          if (key.startsWith("tribuna")) {
            const siteData = this.constantesGlobales[key];
            let child = siteData?.["siteDomain"];

            // ✅ 1. Filtramos el dominio de la web actual Y evitamos duplicados
            if (child && child !== currentDomain && !addedDomains.has(child)) {
              addedDomains.add(child);

              // ✅ 2. Asegurar protocolo HTTPS para evitar bloqueos Mixed Content
              if (!child.startsWith("http")) {
                child = `https://${child}`;
              }

              const seccion = siteData["seccionPrincipal"];
              let url = child + (seccion ? "/" + seccion : "");

              // ✅ 3. Parámetros: inIframe SIEMPRE va primero para evitar fallos de lectura
              const params = [`inIframe=true`];

              // ✅ 4. Solo añadir cookiesAccepted si el consentimiento es explícito
              if (consent && (consent.init === true || consent.rendimiento === true)) {
                params.push(`cookiesAccepted=true`);
              }

              const separator = url.includes("?") ? "&" : "?";
              url += separator + params.join("&");

              tempItems.push({
                url: this.sanitizer.bypassSecurityTrustResourceUrl(url),
                idAnalytic: siteData["idAnalytic"] || "",
                siteName: siteData["siteName"] || "",
                siteDomain: child,
              });
            }
          }
        }
      }

      if (tempItems.length > 0) {
        // ✅ 4. Seleccionar 5 provincias aleatorias
        const selected = this.shuffle(tempItems).slice(0, 5);
        this.dominios = selected.map((item) => item.url);
        this.cd.detectChanges();

        // ✅ 5. Registrar pageview en el GA de cada provincia mostrada (solo una vez)
        if (consent && (consent.init === true || consent.rendimiento === true) && !this.pageviewsSent) {
          this.sendIframePageviews(selected);
          this.pageviewsSent = true;
        }
      }
    } catch (error) {
      console.error("❌ Error cargando iframes:", error);
    }
  }

  /**
   * Envía un page_view al GA4 de cada provincia que se muestra en los iframes.
   * Usa el grupo 'iframe_provinces' para que los eventos posteriores de la página
   * principal NO se envíen a estas propiedades.
   */
  private sendIframePageviews(items: { idAnalytic: string; siteName: string; siteDomain: string }[]): void {
    if (!this.isBrowser) return;

    // console.log("🚀 Enviando pageviews de iframes (Measurement Protocol)...");

    // Obtener el Client ID de Google Analytics si existe, o generar uno aleatorio
    let clientId = "123456789.123456789";
    try {
      const gaCookie = this.cookieService.get("_ga");
      if (gaCookie) {
        const match = gaCookie.match(/GA1\.[0-9]\.(.+)/);
        if (match && match[1]) {
          clientId = match[1];
        }
      } else {
        clientId = Math.round(Math.random() * 2147483647) + "." + Math.round(Date.now() / 1000);
      }
    } catch (e) {
      console.error("❌ Error leyendo cookie _ga", e);
    }

    for (const item of items) {
      if (item.idAnalytic) {
        // Construir la URL base común con todos los parámetros de sesión
        const sid = Math.floor(Date.now() / 1000);
        const ul = navigator.language ? navigator.language.toLowerCase() : "es-es";
        const sr = window.screen ? `${window.screen.width}x${window.screen.height}` : "";
        const vp = window.innerWidth ? `${window.innerWidth}x${window.innerHeight}` : "";
        const cleanDomain = item.siteDomain.endsWith("/") ? item.siteDomain : item.siteDomain + "/";
        
        let baseParams = `&cid=${clientId}&en=page_view&sid=${sid}&sct=1&seg=1&_s=1`;
        baseParams += `&ul=${ul}&sr=${sr}&vp=${vp}`;
        baseParams += `&dl=${encodeURIComponent(cleanDomain)}&dp=%2F&dt=${encodeURIComponent(item.siteName)}`;

        // 1. Enviar hit a la cuenta individual de la provincia
        const urlIndividual = `https://www.google-analytics.com/g/collect?v=2&tid=${item.idAnalytic}${baseParams}`;
        const img = new Image();
        img.src = urlIndividual;
        this.imagePixels.push(img);

        // 2. Enviar hit idéntico a la cuenta Global de certificaciones
        const urlGlobal = `https://www.google-analytics.com/g/collect?v=2&tid=G-G4RC7BX7YM${baseParams}`;
        const imgGlobal = new Image();
        imgGlobal.src = urlGlobal;
        this.imagePixels.push(imgGlobal); // Prevenir Garbage Collection
      }
    }
  }

  ngOnDestroy(): void {
    this.consentSubscription?.unsubscribe();
  }

  shuffle(a: any[]): any[] {
    if (!a || !Array.isArray(a)) return [];

    const array = [...a];
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
}
